//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import Icon from '@components/atoms/icon/Icon';

/**
 * The Spinner renders a 32x32px primary colored loading spinner.
 */
export const Spinner = styled(Icon).attrs({
  name: 'spinner',
})(
  ({ theme }) => `
  width: ${theme.spacings[5]};
  height: ${theme.spacings[5]};
`,
);

/**
 * The InlineSpinner renders a 16x16px, gray version of the standard spinner.
 */
export const InlineSpinner = styled(Spinner)(
  ({ theme }) => `
    display: inline-block;
    width: ${theme.spacings[3]};
    height: ${theme.spacings[3]};

    circle {
      stroke: ${theme.colors.gray4};
    }

    circle.cu-spinner-spiral {
      stroke: ${theme.colors.gray7};
    }
`,
);

/**
 * The CenteredSpinner renders a 32x32px primary colored loading spinner in the center.
 */
export const CenteredSpinner = (
  props: React.HTMLAttributes<HTMLDivElement>,
) => (
  <SpinnerWrap {...props}>
    <Spinner />
  </SpinnerWrap>
);

const SpinnerWrap = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export default Spinner;
